export const LINKS = {
  BOOSTERS_TERMS_OF_USE: 'https://www.rask.ai/booster-terms-of-use',
  PRIVACY_POLICY: 'https://www.rask.ai/privacy-policy',
  PROMOTION_TERMS: 'https://www.rask.ai/promotion-november-18-2025',
  TERMS_OF_SERVICE: 'https://www.rask.ai/terms-of-service',
} as const;
